import React from "react";
import PropTypes from "prop-types";
import { PROCURETOPAY } from "../../../constants/serviceNames";
import BaseRow from "../../tables/baseRow";
import SummaryRow from "../../tables/summaryRow";
import { formatDateTime } from "@sse-digital-services/design-system";
import { parseDateTime } from "utils/dateUtils";

const ProcurementIncidentsRow = ({ item, isEditing }) => {
    let incidentDetails = [
        {
            label: "Description",
            boldLabel: true,
            value: item.description,
        },
        {
            label: "Affected User",
            boldLabel: true,
            value: item.affectedUser,
        },
        {
            label: "Urgency",
            boldLabel: true,
            value: item.priority,
        },
        {
            label: "Updated on",
            boldLabel: true,
            value: formatDateTime(parseDateTime(item.updatedDate)),
        },
        {
            label: "Created on",
            boldLabel: true,
            value: formatDateTime(parseDateTime(item.createdDate)),
        },
    ];

    return (
        <BaseRow itemDetails={incidentDetails}>
            <SummaryRow
                item={item}
                service={PROCURETOPAY}
                isEditing={isEditing}
            />
        </BaseRow>
    );
};
ProcurementIncidentsRow.propTypes = {
    item: PropTypes.object.isRequired,
    isEditing: PropTypes.bool.isRequired,
};

export default ProcurementIncidentsRow;
